import type { QueryClient } from "@tanstack/react-query";

/**
 * Project lists and API-key tables are cached under separate query keys with a
 * 60s staleTime. Creating a project or key must invalidate all of them so the
 * generate-key dropdown and /keys table stay in sync without a full reload.
 */
export const invalidateOrgProjectsAndApiKeys = (queryClient: QueryClient): void => {
  void queryClient.invalidateQueries({ queryKey: ["orgProjectsPage"] });
  void queryClient.invalidateQueries({ queryKey: ["createApiKeyDialogProjects"] });
  void queryClient.invalidateQueries({ queryKey: ["apiKeys"] });
};
